/* Him.clo header — mobile drawer, mega-menu keyboard/tap, search toggle, cart badge sync */
(function () {
  'use strict';

  const DRAWER_OPEN_ATTR = 'data-himclo-drawer-open';

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();

  let initialised = false;
  function init() {
    if (initialised) return;
    initialised = true;
    wireDrawer();
    wireMegaMenu();
    wireSearch();
    wireCartCount();
    wireThemeToggle();
    wireStickyScroll();
    wirePrefetchOnHover();
    wireProductZoom();
  }

  /* ---------- Prefetch product / collection URLs on hover ---------- */
  function wirePrefetchOnHover() {
    const prefetched = new Set();
    const supportsPrefetch = 'prefetch' in (document.createElement('link').relList || {}) ||
                             HTMLLinkElement.prototype.hasOwnProperty('rel');

    const observer = new MutationObserver(scan);
    observer.observe(document.body, { childList: true, subtree: true });
    scan();

    function scan() {
      // Cards on collection / homepage / related products
      const selectors = 'a.hp-card__media, a.hp-card__title, .card-wrapper a[href*="/products/"], .card-wrapper a[href*="/collections/"], .himclo-cg__card, .himclo-tg__card, .himclo-pc__card a, .himclo-header__mega-item';
      document.querySelectorAll(selectors).forEach((a) => {
        if (a.__hcPrefetch) return;
        a.__hcPrefetch = true;
        a.addEventListener('mouseenter', () => queue(a.getAttribute('href')), { once: false });
        a.addEventListener('touchstart', () => queue(a.getAttribute('href')), { once: false, passive: true });
      });
    }
    function queue(href) {
      if (!href || !supportsPrefetch) return;
      if (href.startsWith('#')) return;
      if (prefetched.has(href)) return;
      prefetched.add(href);
      const link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = href;
      link.as = 'document';
      document.head.appendChild(link);
    }
  }

  /* ---------- Product main image zoom (click to open lightbox) ---------- */
  function wireProductZoom() {
    if (!document.body.classList.contains('template-product')) return;

    const openZoom = (src, alt) => {
      const overlay = document.createElement('div');
      overlay.className = 'hc-zoom-overlay';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('aria-label', 'Product image, ' + (alt || ''));
      overlay.innerHTML =
        '<img src="' + src + '" alt="' + (alt || '') + '">' +
        '<button type="button" class="hc-zoom-overlay__close" aria-label="Close zoom">' +
        '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button>';
      document.body.appendChild(overlay);
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(() => overlay.setAttribute('data-visible', ''));

      const close = () => {
        overlay.removeAttribute('data-visible');
        setTimeout(() => {
          overlay.remove();
          document.body.style.overflow = '';
        }, 250);
      };
      overlay.addEventListener('click', (e) => {
        if (e.target === overlay || e.target.closest('.hc-zoom-overlay__close') || e.target.tagName === 'IMG') close();
      });
      document.addEventListener('keydown', function onKey(e) {
        if (e.key === 'Escape') { close(); document.removeEventListener('keydown', onKey); }
      });
    };

    const attach = () => {
      const mediaEls = document.querySelectorAll('.template-product .product__media-list, .template-product .product__media, .template-product .product__media-item.is-active img');
      mediaEls.forEach((el) => {
        if (el.__hcZoom) return;
        el.__hcZoom = true;
        el.addEventListener('click', (e) => {
          const img = el.tagName === 'IMG' ? el : el.querySelector('img');
          if (!img) return;
          // Prefer the highest-res source from srcset
          let src = img.currentSrc || img.src;
          const srcset = img.getAttribute('srcset');
          if (srcset) {
            const last = srcset.split(',').map(s => s.trim().split(' ')[0]).pop();
            if (last) src = last;
          }
          openZoom(src, img.getAttribute('alt') || '');
        });
      });
    };
    attach();
    // Re-scan when Shopify's media gallery swaps active slide
    new MutationObserver(attach).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- Sticky header shrink + blur on scroll ---------- */
  function wireStickyScroll() {
    const header = document.querySelector('.himclo-header--sticky');
    if (!header) return;

    const threshold = 40;
    let scheduled = false;

    const update = () => {
      const scrolled = window.scrollY > threshold;
      header.classList.toggle('is-scrolled', scrolled);
      scheduled = false;
    };

    window.addEventListener('scroll', () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(update);
    }, { passive: true });

    update();
  }

  /* ---------- Dark/Light theme toggle ---------- */
  function wireThemeToggle() {
    const root = document.documentElement;
    const btns = document.querySelectorAll('[data-himclo-theme-toggle]');
    if (!btns.length) return;

    // Templates that lock the theme (e.g. collection = light) hide the toggle.
    if (root.getAttribute('data-template-lock')) {
      btns.forEach((b) => { b.style.display = 'none'; });
      return;
    }

    const apply = (theme) => {
      root.setAttribute('data-theme', theme);
      try { localStorage.setItem('himclo_theme', theme); } catch (e) {}
      btns.forEach((b) => b.setAttribute('aria-label',
        theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'
      ));
      document.dispatchEvent(new CustomEvent('himclo:theme:changed', { detail: { theme } }));
    };

    apply(root.getAttribute('data-theme') || 'dark');

    btns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const current = root.getAttribute('data-theme') || 'dark';
        apply(current === 'dark' ? 'light' : 'dark');
      });
    });
  }

  /* ---------- Mobile drawer ---------- */
  function wireDrawer() {
    const drawer = document.querySelector('[data-himclo-drawer]');
    if (!drawer) return;

    const openBtns  = document.querySelectorAll('[data-himclo-drawer-open]');
    const closeBtns = drawer.querySelectorAll('[data-himclo-drawer-close]');

    const open = () => {
      drawer.setAttribute(DRAWER_OPEN_ATTR, '');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      openBtns.forEach((b) => b.setAttribute('aria-expanded', 'true'));
    };
    const close = () => {
      drawer.removeAttribute(DRAWER_OPEN_ATTR);
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      openBtns.forEach((b) => b.setAttribute('aria-expanded', 'false'));
    };

    openBtns.forEach((b) => b.addEventListener('click', open));
    closeBtns.forEach((b) => b.addEventListener('click', close));

    drawer.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });

    // Nested toggles
    drawer.querySelectorAll('[data-himclo-drawer-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        const sub = btn.parentElement.querySelector('.himclo-drawer__sub');
        btn.setAttribute('aria-expanded', String(!expanded));
        if (sub) {
          if (expanded) sub.setAttribute('hidden', '');
          else sub.removeAttribute('hidden');
        }
      });
    });
  }

  /* ---------- Mega-menu (desktop keyboard / touch) ----------
     CSS already handles :hover / :focus-within. This adds tap support
     on touch devices and Escape-to-close. */
  function wireMegaMenu() {
    const items = document.querySelectorAll('[data-himclo-mega-parent]');
    if (!items.length) return;

    const closeAll = () => items.forEach((it) => {
      it.removeAttribute('data-himclo-mega-open');
      const link = it.querySelector('.himclo-header__nav-link');
      if (link) link.setAttribute('aria-expanded', 'false');
    });

    items.forEach((item) => {
      const link = item.querySelector('.himclo-header__nav-link');
      if (!link) return;

      link.addEventListener('click', (e) => {
        // Only intercept on coarse pointers (touch). Fine pointers use hover.
        if (!window.matchMedia('(pointer: coarse)').matches) return;
        if (window.innerWidth < 990) return; // mobile uses drawer
        const isOpen = item.hasAttribute('data-himclo-mega-open');
        e.preventDefault();
        closeAll();
        if (!isOpen) {
          item.setAttribute('data-himclo-mega-open', '');
          link.setAttribute('aria-expanded', 'true');
        }
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeAll();
    });

    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-himclo-mega-parent]')) closeAll();
    });
  }

  /* ---------- Search toggle ---------- */
  function wireSearch() {
    const openers = document.querySelectorAll('[data-himclo-search-open]');
    const panel   = document.querySelector('[data-himclo-search]');
    const input   = document.querySelector('[data-himclo-search-input]');
    const closer  = document.querySelector('[data-himclo-search-close]');
    if (!panel || !openers.length) return;

    const isHidden = () => panel.hasAttribute('hidden');
    const open = () => {
      panel.removeAttribute('hidden');
      openers.forEach((b) => b.setAttribute('aria-expanded', 'true'));
      requestAnimationFrame(() => input && input.focus());
    };
    const close = () => {
      panel.setAttribute('hidden', '');
      openers.forEach((b) => b.setAttribute('aria-expanded', 'false'));
    };

    openers.forEach((b) => b.addEventListener('click', () => (isHidden() ? open() : close())));
    if (closer) closer.addEventListener('click', close);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !isHidden()) close();
    });
  }

  /* ---------- Live cart count refresh (called by other cart JS) ---------- */
  function wireCartCount() {
    const badge = document.querySelector('[data-himclo-cart-count]');
    if (!badge) return;

    // Listen for a custom event other scripts can fire after add-to-cart.
    document.addEventListener('himclo:cart:updated', (e) => {
      const n = (e.detail && typeof e.detail.count === 'number') ? e.detail.count : null;
      if (n === null) return;
      badge.textContent = String(n);
      badge.classList.toggle('himclo-header__cart-badge--empty', n === 0);
      const btn = badge.closest('.himclo-header__cart');
      if (btn) {
        btn.setAttribute('aria-label', 'Cart, ' + n + ' items');
        // Sprint 3: flash + bump animation
        btn.classList.remove('himclo-header__cart--flash');
        void btn.offsetWidth; // force reflow to restart animation
        btn.classList.add('himclo-header__cart--flash');
        setTimeout(() => btn.classList.remove('himclo-header__cart--flash'), 1000);
      }
    });

    // Also poll /cart.js after quick-add clicks as a fallback.
    document.addEventListener('click', (e) => {
      const t = e.target;
      if (!t.closest('[data-cart-quick-add], [type="submit"][name="add"], [data-add-to-cart]')) return;
      setTimeout(() => {
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then((r) => r.json())
          .then((c) => {
            document.dispatchEvent(new CustomEvent('himclo:cart:updated', { detail: { count: c.item_count } }));
          })
          .catch(() => {});
      }, 250);
    });
  }
})();
